<template>
    <b-overlay class="get-signed-doc_spinner" :show="isOverlayShowing" rounded="sm" :opacity="1" no-fade>
        <p v-if="fileUploaded" class="get-signed-doc_msg">Файл загружен</p>
        <p v-if="fileUploadingError" class="get-signed-doc_msg">Ошибка загрузки файла</p>
        <p v-if="fileUploadingError" @click="prepareData" class="get-signed-doc_msg get-signed-doc_link">Загрузить файл</p>
    </b-overlay>
</template>

<script>
    export default {
        name: 'get-signed-document',
        components: { 
        },

        mounted() {
            this.onMounted();
        },

        data() {
            return {
                requiredParams: ['type', 'id'],
                params: {},
                areAllParamsValid: false,
                isOverlayShowing: false,
                fileUploaded: false,
                fileUploadingError: false
            }
        },
        methods: {
            getLocText(prop) {
                const path = `document_info.${prop}`;
                return this.$t(path);
            },

            onMounted() {
                this.prepareData();
            },

            prepareData() {
                this.fileUploaded = false;
                this.fileUploadingError = false;
                this.areAllParamsValid = this.getUrlParams();
                if (!this.areAllParamsValid) return;
                this.downloadDoc();
            },

            getUrlParams() {
                const urlParams = this.$route.query;
                const missingParams = [];

                for (const par of this.requiredParams) {
                    if (urlParams[par] === undefined) {
                        missingParams.push(par);
                    } 
                }
                if (missingParams.length) {
                    this.makeToast('danger', 'Url Error', `Params "${missingParams.join('", "')}" were lost`);
                    return false;
                } else {
                    for (const par of this.requiredParams) {
                        this.$set(this.params, par, this.$route.query[par]);
                    }

                    return true;
                }
            },

            async downloadDoc() {
                if ('id' in this.params === false) {
                    return this.makeToast('danger', 'Ошибка загрузки файла', 'Нет id фпйла');
                }
                this.isOverlayShowing = true;
                
                fetch(`api/sign/file/get-sign-file-by-id?id=${this.params.id}`, {
                    method: 'GET'
                })
                .then(async (response) => {
                    if (!response.ok) {
                        this.isOverlayShowing = false;
                        this.fileUploadingError = true;
                        return this.makeToast('danger', 'Ошибка загрузки файла', `Ошибка: ${response.status} ${response.statusText}`);
                    }
                    const headers = response.headers;
                    const contentDisposition = headers.get('Content-Disposition');
                    const match = contentDisposition?.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
                    const fileName = match ? decodeURIComponent(match[1]) : 'unnamed-file';

                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(url);
                    this.fileUploaded = true;
                    this.isOverlayShowing = false;
                }).catch(error => {
                    this.isOverlayShowing = false;
                    this.fileUploadingError = true;
                    return this.makeToast('danger', 'Ошибка загрузки файла', `Ошибка: ${error}`);
                });
            },

            makeToast(variant, title, tostbody) {
                this.$bvToast.toast(tostbody, {
                    title: title,
                    variant: variant,
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                    appendToast: true
                });
            }, // сообщение      
        },

        computed: {
            
        }
    }
</script>

<style scoped>
    .get-signed-doc_msg {
        text-align: center;
    }

    .get-signed-doc_spinner {
        height: 30%;
        width: 50%;
        left: 25%;
    }

    .get-signed-doc_link {
        color: #007bff;
        text-decoration: underline;
        cursor: pointer;
    }
</style>
